module.exports = __webpack_public_path__ + "static/media/banner-clients-03.67283ff8.jpg";